export const ALL_TIME_TEXT = "All Time";
export const ASSURANCE_PRODUCT_CATEGORY_SLUG = "assurance";
export const AUTHORIZATION = "authorization";

export const BUTTON_CONFIRM_AND_ISSUE_POLICY = "Confirm And Issue Policy";
export const BUTTON_DASHBOARD = "GO TO HOME";
export const BUTTON_GO_BACK_TO_DASHBOARD = "Go Back To Dashboard";
export const BUTTON_GO_BACK_TO_REVIEW_DETAILS = "Go Back To Assurance Details";
export const BUTTON_PROCESSING = "Processing...";
export const BUTTON_INITIATE_CLAIM = "Initiate Claim";
export const BUTTON_PAY = "PAY ₹";
export const BUTTON_CANCELLATION_INITIATED = "Policy Cancellation Initiated";
export const BUTTON_PENDING_COPAY = "Pending Copay";
export const BUTTON_POLICY_CANCELLED = "Policy Cancelled";
export const BUTTON_SUBMIT = "Submit";

export const CLAIM_REF_NO_TEXT = "Service Request No. ";
export const COLOR_SUCCESS_GREEN = "successGreen";
export const COLOR_DANGER_RED = "dangerRed";
export const COMING_SOON = "Coming Soon";
export const CONFIG_ENTITY_ID = 1;
export const CONFIG_ENTITY_NAME = "SERVICE_CENTER_CONFIG";
export const CREDIT_IN_DAYS = "CREDIT_IN_DAYS";
export const CURRENCY_FORMAT = "en-IN";
export const CUSTOM_DATE_RANGE = "customDateRange";
export const CUSTOMER_OTP_LENGTH = 6;

export const DASHBOARD_SECTION = "Dashboard Section";
export const DASH_SYMBOL = "-";
export const DEALER = "dealer";
export const DEALER_OTP_LENGTH = 6;
export const DEFAULT_VISA_TYPE = "non_immigrant";
export const DELAY_AVERAGE = 5000;  
export const DELAY_LONG = 7000;
export const DELAY_SHORT = 3000;
export const DOWNLOAD = "Download";
export const DOWNLOADING_CERTIFICATE =
  "Downloading certificate, Please wait...";

export const END_TIME = "23:59:59";
export const ENTITY_PRODUCT = "Product";
export const ERROR_MESSAGE_TEXT =
  "It looks like something went wrong. Please try again in a while.";
export const EXPORT_LIST = "Download Claims List";

export const FORMAT_DOB = "DD/MM/YYYY";
export const FORMAT_YYYY_MM_DD = "YYYY-MM-DD";
export const FORMAT_YYYY_MM_DD_HM = "YYYY-MM-DD HH:mm";
export const FORMAT_YYYY_MM_DD_HMS = "YYYY-MM-DD HH:mm:ss";
export const FORMAT_DD_MM_YYYY_HMS = "DD-MM-YYYY HH:mm:ss";
export const FORMAT_DD_MM_YYYY = "DD-MM-YYYY";

export const GST_PERCENTAGE = 18;
export const HANDOVER = "handover";

export const INCLUDING_GST_TEXT = "Including GST";
export const INVOICING_MODAL = "invoicingModal";
export const ISSUE_POLICY = "issuePolicy";

export const LAST_MONTH = "lastMonth";
export const LAST_WEEK = "lastWeek";
export const LOAN_DOCUMENTS = "Loan Documents & Charges";
export const LOAN_ELIGIBILITY_SUMMARY = "Provisional Quotes Summary";
export const LOAN_ACKNOWLEDGEMENT = "Thank you !";
export const LOAN_HANDOVER = "Loan Handover";

export const MASTER_PRODUCT_ID = 74;
export const MODAL_KEY_PREMIUM = "premium";
export const MOTOR = "motor";

export const NAVIGATE_TO = "navigateTo";
export const NEW_CLAIM = "Initiate Claim";
export const NEXT_PAYMENT_DUE_DATE = "Next Payment Due Date";
export const NOT_AVAILABLE = "N/A";
export const NOT_FOUND = "noData";

export const ORDER_ID = "orderId";

export const PARTNER_SLUG = "motor-insurance";
export const PAYG = "PAYG";
export const PAYMENT_GATEWAY = "pg";
export const PAYMENT_GATEWAY_TEXT = "Payment Gateway";
export const PAY_NOW = "Pay Now";
export const PAYMENT_FAILED_MESSAGE =
  "There seems to be a problem in processing your payment.";
export const PAYMENT_PENDING_MESSAGE =
  "Your payment is pending. Please pay to be able to issue new policies.";
export const PAYMENT_SECTION = "Payment Section";
export const PAYMENT_SUCCESS_MESSAGE = "Your payment is successful.";
export const PLAN_NAME_OTSR = "Screen Damage Protection";
export const PLAN_NAME_ADLD = "Complete Damage Protection";
export const PLAN_NAME_EW = "Extended Warranty";
export const POLICIES_SECTION = "Polices Section";
export const POLICY_DOCUMENTS = "Policy Documents";
export const POLICY_GENERATED_SUCCESSFULLY =
  "Certificate Generated Successfully";
export const POLICY_ISSUED_SUCCESSFULLY = "Assurance Issued Successfully";
export const POLICY_SOLD = "Policies Sold";
export const PREPARING_CERTIFICATE = "Preparing certificate, please wait...";
export const PREPARING_POLICY_DOCUMENT =
  "Preparing policy document, please wait...";
export const PREV_X_DAYS = "previousXDays";
export const PRODUCT_ID = "productId";
export const PRODUCT_NAME = "productName";
export const PROPOSAL_STATUS_APPROVED = "approved";
export const PROPOSAL_STATUS_DRAFT = "draft";
export const PROPOSAL_STATUS_INITIATED = "initiated";
export const PROPOSAL_STATUS_REJECTED = "rejected";
export const PROPOSALS_LISTING = "Proposals Listing";
export const PROVIDER_NAME = "providerName";

export const QUERY_STRING_ISSUE_POLICY = "issue_policy";
export const QUOTES_LIST = "quotesList";

export const RANKING = "Ranking";
export const REFRESH_ICON_TOOLTIP = "Click here to fetch original quote";
export const REQUIRED = "required";
export const ROUTE_DASHBOARD = "dashboard";
export const ROUTE_SUCCESS = "success";
export const RUPEE_SYMBOL = "₹";

export const SEARCH_BY_TEXT = "Search by application number or customer name";
export const SELECT_PRODUCT_TITLE = "Select Assurance Product";
export const SOME_THING_WENT_WRONG_TEXT =
  "It looks like something went wrong. Please try again in a while.";
export const SOURCE_POLICY_LISTING = "policy_listing";
export const START_TIME = "00:00:00";

export const THIS_MONTH = "thisMonth";
export const THIS_MONTH_TEXT = "This Month";
export const MONTH_TEXT = "Month";
export const THIS_WEEK = "thisWeek";
export const THIS_WEEK_TEXT = "This Week";
export const WEEK_TEXT = "Week";
export const THIS_YEAR_TEXT = "This Year";
export const YEAR_TEXT = "Year";
export const TODAY = "today";
export const TODAY_TEXT = "Today";
export const TOOLTIP_CHILD_DEALER_EARNING = "GST amount is excluded.";
export const TOOLTIP_DEALER_EARNING = "GST amount is excluded.";
export const TOOLTIP_PARENT_DEALER_EARNING =
  "Includes commission earned from child dealers also. GST amount is excluded.";
export const TOOLTIP_PARENT_DEALER_POLICY_SOLD = null;
/* export const TOOLTIP_PARENT_DEALER_POLICY_SOLD = "Policies sold by child dealers not included."; */
export const TOTAL_EARNIGS = "Total Earnings";

export const USER = "user";
export const USER_DETAILS = "user_details";

export const VALID = "valid";
export const VEHICLE_TYPE_NEW = "NEW";
export const VEHICLE_TYPE_OLD = "OLD";

export const CLAIM_STATUS_SUBMITTED = "SUBMITTED";
export const CLAIM_STATUS_APPROVED = "APPROVED";
export const CLAIM_STATUS_SETTLED = "SETTLED";
export const CLAIM_STATUS_IN_PROGRESS = "IN PROGRESS";

export const CLAIM_STATUS_MAPPING = {
  "Claim Submitted": CLAIM_STATUS_SUBMITTED,
  "Claim Initiated": CLAIM_STATUS_SUBMITTED,
  Rejected: CLAIM_STATUS_IN_PROGRESS,
  Approved: CLAIM_STATUS_APPROVED,
  "Settlement Completed": CLAIM_STATUS_SETTLED,
};

export const CLAIMS_LISTING = "Claims Listing";
export const BUTTON_UPLOAD_INVOICE = "INVOICE";
export const BUTTON_INVOICE_UPLOADED = "INVOICE";
export const BUTTON_UPLOAD_REPAIRED_MOBILE = "MOBILE";
export const BUTTON_REPAIRED_MOBILE_UPLOADED = "MOBILE";
export const DOCUMENT_CDN_PATH =
  "https://toffee-cdn-qa.s3.ap-south-1.amazonaws.com/";
export const NOT_AVAILABLE_TEXT = "Not Available";
export const PARTNER_ID_MOBILE_STACK_DEMO = 191;
export const DOCUMENT_TPYE_ID_AADHAAR = 1;
export const DOCUMENT_TPYE_ID_ESTIMATE = 15;
export const DOCUMENT_TPYE_ID_INVOICE = 16;
export const DOCUMENT_TPYE_ID_MOBILE_PHOTOS = 73;
export const DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS = 74;
export const NO_ACTIVE_POLICY_TO_CLAIM_TEXT =
  "There is no active policy to start a new claim.";

export const RAZORPAY_OPTIONS_NAME = "Garantie";
export const RAZORPAY_OPTIONS_DESCRIPTION = "Copay Amount";
export const RAZORPAY_OPTIONS_IMAGE =
  "https://qa.toffeeinsurance.com/images/192x192-garantie.png";
export const RAZORPAY_OPTIONS_CURRENCY = "INR";
export const RAZORPAY_OPTIONS_ENTITY_NAME = "claim";
export const REJECTION_REASON_TEXT = "Rejection Reason:";
export const CANCELLATION_REASON_TEXT = "Cancellation Reason:";

export const MOBILE_OTSR_PRODUCT_ID = 63;
export const MOBILE_ADLD_PRODUCT_ID = 67;
export const MOBILE_EW_PRODUCT_ID = 92;
export const CLAIM_STATUS_INITIATED_SLUG = "initiated";
export const CLAIM_STATUS_REJECTED_SLUG = "rejected";
export const CLAIM_STATUS_CANCELLED_SLUG = "claim cancelled";
export const WHAT_NEXT_TEXT = "What Next";
export const WHAT_NEXT_TOOLTIP =
  "Please take your device to the preferred service centre or any nearest service centre.";
export const DEFAULT_CITY_NAME = "Gurgaon";
export const DEFAULT_STATE_NAME = "Haryana";
export const DEFAULT_PINCODE = 122001;
export const DATE_OF_DAMAGE_SLUG = "date_of_damage";
export const LOCATION_OF_DAMAGE_SLUG = "location_of_damage";
export const DAMAGE_DETAILS_SLUG = "damage_details";
export const DAMAGED_CYCLE_PARTS_SLUG = "damaged_cycle_parts";
export const DAMAGED_ASSET_PARTS_LIST = [
  "Display Screen",
  "Battery",
  "Camera Lens",
  "Charging Port",
  "Speaker and Microphone",
  "SIM Card Tray",
  "Antenna",
  "Others",
];
export const GB_SLUG = "GB";
export const USER_DETAILS_SLUG = "user_details";
export const MOBILE_PRODUCT_IDS = [
  MOBILE_OTSR_PRODUCT_ID,
  MOBILE_ADLD_PRODUCT_ID,
  MOBILE_EW_PRODUCT_ID,
];
export const POLICY_CANCELLATION_INITIATED_STATUS_ID = 26;
export const POLICY_CANCELED_STATUS_ID = 27;
export const CANCELLED_POLICIES_STATUS_IDS = [
  POLICY_CANCELLATION_INITIATED_STATUS_ID,
  POLICY_CANCELED_STATUS_ID,
];
export const CANCELLATION_INITIATED_WHAT_NEXT_TOOLTIP =
  "Waiting for policy cancellation approval.";
export const CURRENT_POLICY_STATUS = "Current Status";
export const PREFERRED_DATE = "preferred_date";
export const DAMAGE_DATE = "damage_date";
export const PREFERRED_TIMESLOT = "preferred_timeslot";
export const TOOLTIP_CLAIM_PROCESSING_CHARGE =
  "This is a processing fee that needs to be paid <br /> to your claim. For more details please refer <br /> section 3.1 of your policy document mailed to you.";
export const PENDING = "Pending";
export const NEAREST_SERVICE_CENTRES_LIST = "Nearest Service Centres";
export const SERVICE_CENTRE_DETAILS = "Service Centre Details";
export const COPAYMENT_NOT_APPLICABLE_PRODUCTS = [92]; // 63, 92
export const NOTE_CLAIM_PROCESSING_CHARGE =
  "Please pay the claim processing fee as co-pay. This amount will be refunded if the claim is rejected. Please refer your plan";
export const TERMS_AND_CONDITION = "terms and conditions.";
export const COPAYMENT_PRODUCTS = [63, 67]; // 67
export const SLUG_SKIP_COPAYMENT = "SKIP_COPAYMENT";
